export const FETCH_SHOP_LIST = {
  init: 'shops/FETCH_SHOP_LIST/init',
  request: 'shops/FETCH_SHOP_LIST/request',
  success: 'shops/FETCH_SHOP_LIST/success',
  failure: 'shops/FETCH_SHOP_LIST/failure',
  cancel: 'shops/FETCH_SHOP_LIST/cancel',
} as const;

export const SHOPS_STORE_NAME = 'shops' as const;
